<template>
  <div class="student-schedule-container">
    <Forbidden v-if="getUserRole[getUserRole.length - 1].role_id == 0" routerPath="notLogin" />
    <Forbidden
      v-else-if="
      !getHasProgramRegistered || 
      getUserRole[getUserRole.length - 1].role_id != userRole.STUDENT || 
      getStudentTermStatus == termStatus.TERM_BREAK ||
      getPaymentStatus != paymentState.ACCEPTED"
      routerPath="incorrectRole"
    />
    <Forbidden
      v-else-if="
      !getSchedulePeriodOpened && 
      !getClassPeriodOpened"
      routerPath="notInPeriod"
    />
    <section v-else class="student-schedule-container vector-background">
      <b-container>
        <b-alert :show="this.success" dismissible fade variant="success">Berhasil melakukan aksi !</b-alert>
        <b-row align-h="center">
          <b-col sm="12" md="8">
            <h3 class="header-title">Pilih Jadwal Setoran</h3>
            <b-calendar
              block
              hide-header
              class="calendar"
              :initial-date="dateMin._d"
              v-model="selectedDate"
              @click.native="addSelectedDate"
              locale="en"
            ></b-calendar>
            <div class="note-container">
              <div class="indicator-container" v-for="(data, index) in indicators" :key="index">
                <div class="indicator" :class="data.indicator"></div>
                <p class="note">{{ data.note }}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="12" md="4">
            <div class="detail-pilihan-container">
              <h3 class="header-title">Detail Pilihan</h3>
              <p class="no-date" v-if="listSelectedDate.length == 0">Kamu belum memilih jadwal</p>
              <div class="detail-pilihan-wrapper">
                <div
                  class="detail-pilihan-card"
                  v-for="(data, index) in listSelectedDate"
                  :key="index"
                >
                  <div class="selected-date">
                    <p class="date">{{ changeDatetimeToLocaleDate(data.start_datetime) }}</p>
                  </div>
                  <div class="detail-wrapper">
                    <p class="time">
                      {{ changeDatetimeToTime(data.start_datetime) }} -
                      {{ changeDatetimeToTime(data.end_datetime) }}
                    </p>
                    <p class="teacher">Ust. {{ data.teacher.full_name }}</p>
                  </div>
                  <button class="btn" @click="editClass(data)">Ubah</button>
                </div>
              </div>
              <router-link v-if="listSelectedDate.length != 0" to="/transaction">
                <button class="submit btn primary">Selanjutnya</button>
              </router-link>
            </div>
          </b-col>
        </b-row>
        <b-modal
          v-model="isModal"
          class="modal"
          size="sm"
          hide-footer
          centered
          no-close-on-backdrop
          header-class="no-header"
          :title="selectedDate"
        >
          <div class="custom-modal-header">
            <h4 class="header-title">Detail Pilihan</h4>
            <div class="close" @click="cancelJoin">×</div>
          </div>
          <div class="modal-content">
            <b-form @submit.stop.prevent="handleSubmit(studentModal)">
              <b-row>
                <b-col>
                  <b-form-group id="time-group" label="Waktu" label-for="time">
                    <b-form-select id="time" v-model="timeId" :options="timeOption" required>
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </div>
          <div class="modal-footer" v-if="edit">
            <button v-b-modal.konfirmasi-hapus class="btn danger">Hapus</button>
            <button @click="joinClass" class="btn primary">Ubah</button>
          </div>
          <div class="modal-footer" v-else>
            <button @click="cancelJoin" class="btn">Batal</button>
            <button @click="joinClass" class="btn primary">Ikut</button>
          </div>
          <b-modal id="konfirmasi-hapus" size="sm" hide-footer title="Konfirmasi untuk menghapus">
            <p class="my-2">Apakah anda yakin untuk menghapus jadwal ini ?</p>
            <div class="modal-footer">
              <button @click="cancelJoin" class="btn">Batal</button>
              <b-button @click="deleteClass" class="btn danger">Hapus</b-button>
            </div>
          </b-modal>
        </b-modal>
      </b-container>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import User from "@/services/User";
import Forbidden from "@/views/Forbidden.vue";
import moment from "moment/moment";
import store from "@/store";
import { UserRole, TermStatus } from "@/services/StatusCode";
import { paymentState } from "@/store/modules/Transaction";

export default {
  name: "StudentSchedule",
  components: {
    Forbidden
  },
  data() {
    return {
      dateMin: moment(store.getters.getPeriodStart("class")),
      dateMax: moment(store.getters.getPeriodEnd("class")),
      selectedDate: "",
      form: {},
      success: false,
      timeId: "",
      timeEditId: "",
      timeOption: [],
      listSelectedDate: [],
      availableDate: [],
      isModal: false,
      edit: false,
      indicators: [
        { indicator: "primary", note: "Belum terisi" },
        { indicator: "secondary", note: "Masih tersedia" },
        {
          indicator: "danger",
          note: "Sudah penuh"
        }
      ],
      userRole: UserRole,
      termStatus: TermStatus,
      paymentState: paymentState
    };
  },
  methods: {
    editClass(data) {
      this.edit = true;
      this.selectedDate = this.changeDatetimeToDate(data.start_datetime);
      this.printAvailableDate();
      this.timeId = data.id;
      this.timeEditId = data.id;
      this.timeOption = [
        {
          value: data.id,
          text: `${this.changeDatetimeToTime(
            data.start_datetime
          )} - ${this.changeDatetimeToTime(data.end_datetime)} (Ust. ${
            data.teacher.full_name
          })`,
          disabled: true
        }
      ];
      this.addSelectedDate();
    },
    deleteClass() {
      this.changeFormFromId(this.timeEditId);
      const begin = moment(this.selectedDate);
      begin.subtract(1, "day");
      if (moment().isSameOrAfter(begin, "day")) {
        store.dispatch("showAlertError", {
          title: "Gagal melakukan aksi",
          message:
            "Sesi jadwal yang diubah atau ditambah hanya dalam waktu 2 hari ke depan."
        });
        return;
      }
      this.deleteAPI().finally(() => {
        this.resetModal();
      });
    },
    joinClass() {
      if (this.edit) {
        this.changeFormFromId(this.timeEditId);
        const begin = moment(this.selectedDate);
        begin.subtract(1, "day");
        if (moment().isSameOrAfter(begin, "day")) {
          store.dispatch("showAlertError", {
            title: "Gagal melakukan aksi",
            message:
              "Sesi jadwal yang diubah atau ditambah hanya dalam waktu 2 hari ke depan."
          });
          return;
        }
        this.deleteAPI();
      }
      this.changeFormFromId(this.timeId);
      this.addAPI().finally(() => {
        this.resetModal();
      });
    },
    changeFormFromId(timeId) {
      let selectedSession = this.availableDate.find(({ id }) => id == timeId);
      if (selectedSession == undefined) {
        selectedSession = this.listSelectedDate.find(({ id }) => id == timeId);
      }
      this.form = selectedSession;
    },
    async addAPI() {
      await User.sendStudentSchedule(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.form.id
      )
        .then(() => {
          this.success = true;
          this.getAvailableDate();
        })
        .catch(() => {
          this.fail = true;
        });
    },
    async deleteAPI() {
      await User.deleteStudentSchedule(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.form.id
      )
        .then(() => {
          this.success = true;
          this.getAvailableDate();
        })
        .catch(() => {
          this.fail = true;
        });
    },
    cancelJoin() {
      this.resetModal();
      this.printAvailableDate();
    },
    resetModal() {
      this.isModal = false;
      this.edit = false;
      this.timeOption = [];
      this.selectedDate = "";
    },
    addSelectedDate() {
      if (this.selectedDate != "") {
        const session = this.availableDate.filter(data => {
          return (
            this.changeDatetimeToDate(data.start_datetime) == this.selectedDate
          );
        });
        session.forEach(data => {
          this.timeOption.push({
            value: data.id,
            text: `${this.changeDatetimeToTime(
              data.start_datetime
            )} - ${this.changeDatetimeToTime(data.end_datetime)} (Ust. ${
              data.teacher.full_name
            })`,
            disabled: false
          });
        });
        this.isModal = true;
      } else {
        this.printAvailableDate();
      }
    },
    initiateDate() {
      document
        .querySelectorAll(
          ".b-calendar-grid-body .row.no-gutters div[role='button'"
        )
        .forEach(btn => {
          btn.classList.add("disable");
        });
    },
    printAvailableDate() {
      this.initiateDate();
      this.listSelectedDate.forEach(data => {
        const date = document.querySelector(
          "div[data-date='" +
            this.changeDatetimeToDate(data.start_datetime) +
            "']"
        );
        if (date != null) {
          date.classList.replace("disable", "notAvailable");
          date.classList.replace("halfAvailable", "notAvailable");
          date.classList.replace("available", "notAvailable");
        }
      });
      this.availableDate.forEach(data => {
        const startDate = this.changeDatetimeToDate(data.start_datetime);
        const dateBtn = document.querySelector(
          "div[data-date='" + startDate + "']"
        );
        const isDateHasStudent =
          this.listSelectedDate.find(date => {
            return date.start_datetime == data.start_datetime;
          }) != undefined;
        if (dateBtn != null) {
          if (isDateHasStudent) {
            dateBtn.classList.replace("notAvailable", "halfAvailable");
            dateBtn.classList.replace("available", "halfAvailable");
            dateBtn.classList.replace("disable", "halfAvailable");
          } else {
            dateBtn.classList.replace("notAvailable", "available");
            dateBtn.classList.replace("halfAvailable", "available");
            dateBtn.classList.replace("disable", "available");
          }
        }
      });
    },
    pushResponseToData(response) {
      const studentNull = response.filter(data => {
        const sessionStart = moment(data.start_datetime);
        return (
          moment().isBefore(sessionStart, "day") &&
          sessionStart.isAfter(this.dateMin) &&
          sessionStart.isBefore(this.dateMax) &&
          data.student == null
        );
      });
      const studentNotNull = response.filter(data => {
        const sessionStart = moment(data.start_datetime);
        return (
          moment().isSameOrBefore(sessionStart, "day") &&
          sessionStart.isAfter(this.dateMin) &&
          sessionStart.isBefore(this.dateMax) &&
          data.student != null
        );
      });
      this.availableDate = studentNull;
      this.listSelectedDate = studentNotNull;
    },
    async getAvailableDate() {
      await User.getTeacherAvailableSchedule(
        process.env.VUE_APP_URL,
        this.getTermName,
        this.getAccessToken
      ).then(response => {
        this.pushResponseToData(response);
        this.printAvailableDate();
      });
    },
    changeDatetimeToTime(datetime) {
      const date = moment(datetime);
      date.locale("id");
      return date.format("HH:mm");
    },
    changeDatetimeToDate(datetime) {
      const date = moment(datetime);
      date.locale("id");
      return date.format("YYYY-MM-DD");
    },
    changeDatetimeToLocaleDate(datetime) {
      const date = moment(datetime);
      date.locale("id");
      return date.format("DD MMMM YYYY");
    }
  },
  async created() {
    await User.getLatestPeriod(process.env.VUE_APP_URL);
    if (
      this.getUserRole[this.getUserRole.length - 1].role_id != 0 &&
      this.getUserRole[this.getUserRole.length - 1].role_id ==
        UserRole.STUDENT &&
      (this.getSchedulePeriodOpened || this.getClassPeriodOpened)
    ) {
      this.getAvailableDate();
    }
  },
  computed: {
    ...mapGetters({
      getTermName: "getTermName",
      getAccessToken: "getAccessToken",
      getUserRole: "getUserRole",
      getSchedulePeriodOpened: "getSchedulePeriodOpened",
      getClassPeriodOpened: "getClassPeriodOpened",
      getFirstname: "getFirstname",
      getLastname: "getLastname",
      getStudentTermStatus: "getStudentTermStatus",
      getHasProgramRegistered: "getHasProgramRegistered",
      getPaymentStatus: "getPaymentStatus",
    })
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/form.scss";

.btn {
  margin-left: $gap-sm-2;
}

.header-wrapper {
  display: flex;
  align-items: center;

  .header-title {
    margin-right: $gap-sm-4;
  }
}

.header-title {
  text-align: center;
  color: #000;
  font-weight: bold;
}

.note-container {
  display: flex;
  flex-direction: column;
  margin-bottom: $gap-m-2;

  .indicator-container {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;

    .indicator {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin: 0 $gap-sm-2;

      &.primary {
        background: $primary;
      }

      &.secondary {
        background: $secondary;
      }

      &.danger {
        background: $danger;
      }
    }
  }
}

.student-schedule-container {
  min-height: inherit;

  .header-title {
    font-weight: bold;
    margin: $gap-m-1 0;
  }

  .container {
    min-height: inherit;
    padding-top: $gap-m-2;
  }

  b-row {
    min-height: inherit;
  }

  b-col {
    min-height: inherit;
  }

  .detail-pilihan-container {
    padding: $gap-m-1;
    box-shadow: 0 0 6px rgba($color: #aaa, $alpha: 0.12);
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    .detail-pilihan-wrapper {
      padding: 0 $gap-sm-2;
      border-radius: 20px;
      overflow-y: auto;
      max-height: 600px;
      scrollbar-width: 0;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .no-date {
      text-align: center;
      margin: $gap-m-2 0;
    }

    .submit {
      margin: $gap-m-1 0 $gap-sm-2 0;
      align-self: flex-end;
    }

    .detail-pilihan-card {
      box-shadow: 0 0 6px rgba($color: #aaa, $alpha: 0.12);
      padding: $gap-m-1;
      border-radius: 10px;
      margin: $gap-m-2 0;
      display: flex;
      flex-direction: column;

      .selected-date {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: $gap-m-1;

        p {
          padding: $gap-sm-1 $gap-sm-2;
          background: $primary;
          color: $white;
          border-radius: 10px;
        }
      }

      .detail-wrapper {
        margin-bottom: $gap-sm-2;

        .time {
          font-weight: 600;
        }
      }

      button.detail {
        align-self: flex-end;
      }
    }
  }
}
</style>
